module.exports = __webpack_public_path__ + "static/edit-language-file-7ba009517d6fb0ed5c34d69f10bfecaa.png";